import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import IndicatorCard from './components/indicator-card';
import BuySellMetals from './components/buy-sell-metals';
import DashboardBanner from './components/dashboard-banner';
import PageHeader from '../../shared/page-header';
import { dashboardStore } from '../../store/DashboardStore';
import { userStore } from '../../store/UserStore';
import DashboardService from '../../services/dashboard.service';
import RealisedService from '../../services/realised.service';
import Loader from '../../shared/common/loader';
// import Banner from '../../assets/images/banner.jpg';
import Banner from '../../assets/images/banner2.png'
import { formatAmount } from '../../utils';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Pushnotification from '../login/services/login.service';
import { getMessaging, getToken } from 'firebase/messaging';
import { app, db, auth } from '../../firebaseConfig';
import RedeemGiftModal from 'pages/gift-module/RedeemGiftModal';
import { useHistory } from 'react-router-dom';
// import SupportButton from 'shared/common/supportButton/SupportButton';
// import SupportButton from 'shared/common/supportButton/SupportButton';
import downArrow from 'assets/icons/chevron-down.svg';
import upArrow from 'assets/icons/chevron-up.svg';
import { toast } from 'react-toastify';
import './index.css';
const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

interface PropsType {}

const DashboardPage: React.FC<PropsType> = () => {
  const renderCheck = useRef(false);
  // eslint-disable-next-line
  const [
    customerHolding,
    wallet,
    summary,
    accountsHolding,
    metals,
    setCustomerHolding,
    setAccountHolding,
    setWallet,
    setSummary,
    setMetals,
  ] = dashboardStore((state: any) => [
    state.customerHolding,
    state.wallet,
    state.summary,
    state.accountsHolding,
    state.metals,
    state.setCustomerHolding,
    state.setAccountHolding,
    state.setWallet,
    state.setSummary,
    state.setMetals,
  ]);
  const [customerId, user, selectedAccount, customer] = userStore(
    (state: any) => [
      state.customerId,
      state.user,
      state.selectedAccount,
      state.customer,
    ]
  );

  // const metalObj = ['Ag', 'Pd', 'Pt', 'Au'];
  const [loading, setLoading] = useState<boolean>(false);
  const [realisedLoading, setRealisedLoading] = useState<boolean>(false);
  const [holdings, setHoldings] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const [realisedData, setRealisedData] = useState<any>();
  const [unRealisedData, setUnRealisedData] = useState<any>();
  let arrayOfObjects;
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const gift = searchParams.get('gift');

  const decodedMetal = gift ? decodeURIComponent(gift) : undefined;

  useEffect(() => {
    if (selectedAccount) {
      let acHoldings = accountsHolding.find(
        (acc) => acc.accountId === selectedAccount.accountId
      );
      if (acHoldings) setHoldings(acHoldings.accountHolding);
    }
  }, [accountsHolding, selectedAccount]);

  useEffect((): any => {
    getPassbookSummary();
    getAllMetals();
    storeFCMToken();
    document.title = 'Dashboard - RBK GFS';
  }, []);

  useEffect(() => {
    if (renderCheck.current) {
      getPassbookSummary();
      getAllMetals();
    } else {
      renderCheck.current = true;
    }
  }, [customerId]);

  /**
   * Get passbook summary details
   */
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setCustomerHolding(
          res.data.data.metal.customerHolding.sort((a: any, b: any) =>
            a.metal.localeCompare(b.metal)
          )
        );
        setAccountHolding(res.data.data.metal.accountsHolding);
        setWallet(res.data.data.wallet);
        setSummary(res.data.data.summary);

        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  /**
   * Get all metals
   */
  const getAllMetals = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getAllMetals();
      if (res.status === 200 && res.data.data.result.length > 0) {
        setMetals(res.data.data.result);
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const storeFCMToken = async () => {
    try {
      const messaging = getMessaging(app);
      const userId = user?.customers[0]?.user?.userId;

      // Retrieve the FCM token
      getToken(messaging)
        .then(async (token) => {
          const data = { webtoken: token, user_id: userId };
          const storeToken = await Pushnotification.storeFcmToken(data);
          // console.log('FCM Token:', token);
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const claimGift = () => {
    history.push('/gift?giftListReceived=true');
  };
  const onCancel = () => {
    localStorage.setItem('popupGiftShown', 'true');

    setOpen(false);
  };

  // realised data
  const profitLoss = async () => {
    try {
      const data = { customerId: customerId };
      setRealisedLoading(true);
      const res = await RealisedService.realisedData(
        data,
        user?.userId,
        user?.partner?.id
      );
      if (res.status == 200) {
        const newdata: Object = res.data.data.Realised;
        // arrayOfObjects = Object.entries(newdata).map(([key, value]) => ({
        //   metal: key,
        //   ...value,
        // }));
        setRealisedData(res?.data?.data?.Realised);
        setUnRealisedData(res?.data?.data?.Unrealised);
        setRealisedLoading(false);

        // console.log('realiseddata', arrayOfObjects);
      } else {
        // setRealisedLoading(false);

        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      setRealisedLoading(false);

      toast.error('Something went wrong');
    }
  };
  useEffect(() => {
    profitLoss();
    const hasPopupBeenShown = localStorage.getItem('popupGiftShown');
    if (
      !hasPopupBeenShown &&
      customer?.giftCount > 0 &&
      customer?.customerCategory === 'UNREGISTERED'
    ) {
      setOpen(true);
      localStorage.setItem('popupGiftShown', 'true');
    }
  }, []);

  const investedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.sell_price,
      0
    );
  const markToMarkSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalSellAmount,
      0
    );
  const unInvestedSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalBuybackAmount,
      0
    );

  const realisedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.buyback_price,
      0
    );

  const realisedPLSum = realisedMetalSum - investedMetalSum;
  const unrealisedPLSum = markToMarkSum - unInvestedSum;
  const realisedPLSumPer =
    investedMetalSum > 0
      ? ((realisedMetalSum - investedMetalSum) / investedMetalSum) * 100
      : realisedMetalSum > 0
      ? 100
      : 0;
  const unrealisedPLSumPer =
    unInvestedSum > 0
      ? ((markToMarkSum - unInvestedSum) / unInvestedSum) * 100
      : markToMarkSum > 0
      ? 100
      : 0;

  useEffect(() => {
    const sipLSdata = localStorage.getItem('sipdata');
    if (sipLSdata!==null) {
      history.push({
        pathname: '/sip',
        state: { sipdata: JSON.parse(sipLSdata) },
      });
    }

    const manualSipLSdata = localStorage.getItem('manualSipData');
    if (manualSipLSdata !== null) {
      const manualSipObj = JSON.parse(manualSipLSdata);
      const manualSipEncObj = encodeURIComponent(manualSipLSdata);

      let redirectUrl = `/sip-payment-schedule/${manualSipObj?.sipId}?data=${manualSipEncObj}`;
      history.push(
        redirectUrl,
      );
    }
  }, []);
  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/*<Toast/>*/}
          <PageHeader
            mainTitle={user.displayName}
            subTitle='Below are your total holdings'
          />

          <Row>
            <Col md={8}>
              <Row>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading='Metal Holdings'
                      amount={`₹ ${
                        formatAmount(summary.metalBalance) || '0.00'
                      }`}
                      backgroundColor='#2575fc'
                      addClassName='py-2 tot-card'
                      styles=''
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading='In Wallet'
                      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}
                      styles=''
                      addClassName='wallet '
                      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}
                    />
                  </div>
                </Col>
              </Row>
              {/*<div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="Total Holdings"*/}
              {/*      amount={`₹ ${formatAmount(summary.walletBalance + summary.metalBalance) || '0.00'}`}*/}
              {/*      backgroundColor="#2575fc"*/}
              {/*      addClassName="h-100 tot-card"*/}
              {/*      styles=""*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="In Wallet"*/}
              {/*      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}*/}
              {/*      styles=""*/}
              {/*      addClassName="wallet "*/}
              {/*      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*</div>*/}
              <div className='col-md-8 overflow-auto d-sm-block d-md-none'>
                <div className='d-flex flex-column bd-highlight'>
                  {holdings?.map((account: any, index: number) => (
                    <div className='mb-2 flex-fill flex-shrink-0'>
                      <div key={index} className=''>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={
                            metalsWithCode.filter(
                              (x: any) => x.code === account.metal
                            ).length > 0
                              ? metalsWithCode.filter(
                                  (x: any) => x.code === account.metal
                                )[0].name
                              : ''
                          }
                          amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                          quantity={`${account.quantity?.toFixed(4)}`}
                          addClassName={`${account.metal} metal mobileCard`}
                          earmarkedBalance={account.lockQuantity || ''}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='d-md-grid grid d-sm-flex mt-2 d-none d-sm-block'>
                {holdings?.map((account: any, index: number) => (
                  <div key={index}>
                    <IndicatorCard
                      // eslint-disable-next-line react/no-array-index-key
                      isMain={false}
                      heading={
                        metalsWithCode.filter(
                          (x: any) => x.code === account.metal
                        ).length > 0
                          ? metalsWithCode.filter(
                              (x: any) => x.code === account.metal
                            )[0].name
                          : ''
                      }
                      metalCode={account.metal}
                      redirectLink={`/passbook?metalCode=${account.metal}`}
                      amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                      quantity={`${account.quantity?.toFixed(4)}`}
                      addClassName={`${account.metal} metal`}
                      earmarkedBalance={account.lockQuantity || ''}
                    />
                  </div>
                ))}
                {customerHolding && customerHolding.length === 0 ? (
                  <>
                    {[1, 2, 3, 4].map((item: any, index: number) => (
                      <div key={index}>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={null}
                          amount={null}
                          quantity={null}
                          addClassName={` metal`}
                          earmarkedBalance={null}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
              <DashboardBanner image={Banner} />
            </Col>
            <Col md={4}>
              <BuySellMetals
                metals={metals}
                walletBalance={summary.walletBalance}
                isDashboard={true}
                getPassbookSummary={getPassbookSummary}
                giftMetal={decodedMetal}
              />
            </Col>
          </Row>
          {/* <SupportButton /> */}
          <Row className='mt-5 mb-3'>
            {realisedLoading ? (

              // <Spinner animation='border' variant='primary' role='status'>
             
              //   {/* <span className='visually-hidden'>Loading...</span> */}
              // </Spinner>
              // <Spinner animation='border' variant='primary' role='status'>
              //   {/* <span className='visually-hidden'>Loading...</span> */}
              // </Spinner>
              <span style={{display:'flex', justifyContent:'center', textAlign:'center'}}>Loading...</span>
            ) : (
              realisedData && (
                <>
                  <Col md={6}>
                    <h5>BOOKED GAIN / LOSS</h5>
                    <div className='table-real-container overflow-auto'>
                      <table className='custom-table' style={{ height: 300 }}>
                        <thead>
                          <tr>
                            <th className='center-align'>Metal</th>
                            {realisedData &&
                              Object.keys(realisedData).map((metalCode) => {
                                const metalObject = metalsWithCode?.find(
                                  (metal) => metal?.code === metalCode
                                );
                                const metalName = metalObject
                                  ? metalObject?.name
                                  : metalCode;
                                return (
                                  <th key={metalCode} className='center-align'>
                                    {metalName}
                                  </th>
                                );
                              })}
                            <th className='center-align'>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td className='left-align'>
                              <b>Invested Metal Value</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-sold`}
                                  className='right-align'
                                >
                                  ₹{realisedData[metal].sell_price.toFixed(2)}
                                </td>
                              ))}
                          </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Invested Metal Value</b>
                            </td>
                            {Object.keys(realisedData).map((metal) => (
                              <td key={`${metal}-sold`} className='right-align'>
                                ₹{realisedData[metal].sell_price.toFixed(2)}
                              </td>
                            ))}
                            <td className='right-align'>
                              ₹{investedMetalSum.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className='left-align'>
                              <b>Realised Metal Value</b>
                            </td>

                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-investment`}
                                  className='right-align'
                                >
                                  ₹
                                  {realisedData[metal].buyback_price.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{realisedMetalSum.toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Metal Transacted</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  {realisedData[metal].quantity.toFixed(4)} g
                                </td>
                              ))}
                            <td className='center-align'>-</td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (INR)</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  className='right-align'
                                  style={{ padding: '5px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {realisedData[metal].buyback_price.toFixed(
                                      2
                                    ) -
                                      realisedData[metal].sell_price.toFixed(
                                        2
                                      ) !=
                                    0 ? (
                                      realisedData[metal].buyback_price.toFixed(
                                        2
                                      ) -
                                        realisedData[metal].sell_price.toFixed(
                                          2
                                        ) >
                                      0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      ₹
                                      {Math.abs(
                                        realisedData[metal].buyback_price -
                                          realisedData[metal].sell_price
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              ))}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedPLSum != 0 ? (
                                  realisedPLSum > 0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹{Math.abs(realisedPLSum).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (%)</b>
                            </td>
                            {realisedData &&
                              Object.keys(realisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  className='right-align'
                                  style={{ padding: '5px' }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {realisedData[metal].buyback_price.toFixed(
                                      2
                                    ) -
                                      realisedData[metal].sell_price.toFixed(
                                        2
                                      ) !=
                                    0 ? (
                                      realisedData[metal].buyback_price.toFixed(
                                        2
                                      ) -
                                        realisedData[metal].sell_price.toFixed(
                                          2
                                        ) >
                                      0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      {realisedData[metal].sell_price > 0
                                        ? Math.abs(
                                            ((realisedData[metal]
                                              .buyback_price -
                                              realisedData[metal].sell_price) /
                                              realisedData[metal].sell_price) *
                                              100
                                          ).toFixed(2)
                                        : realisedData[metal].buyback_price > 0
                                        ? 100
                                        : 0}
                                      %
                                    </span>
                                  </div>
                                </td>
                              ))}

                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedPLSumPer !== 0 ? (
                                  <>
                                    {realisedPLSumPer > 0 ? (
                                      <img
                                        src={upArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={downArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                                <span>
                                  {realisedPLSumPer !== 0 ? Math.abs(realisedPLSumPer).toFixed(2): 0}%
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col md={6} className='mob-table-margin'>
                    <h5>POTENTIAL GAIN / LOSS</h5>
                    <div className='table-real-container overflow-auto'>
                      <table className='custom-table' style={{ height: 300 }}>
                        {/* <table className='custom-table' > */}
                        <thead>
                          <tr>
                            <th className='center-align'>Metal</th>
                            {realisedData &&
                              Object.keys(realisedData).map((metalCode) => {
                                const metalObject = metalsWithCode.find(
                                  (metal) => metal.code === metalCode
                                );
                                const metalName = metalObject
                                  ? metalObject.name
                                  : metalCode;
                                return (
                                  <th key={metalCode} className='center-align'>
                                    {metalName}
                                  </th>
                                );
                              })}
                            <th className='center-align'>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='left-align'>
                              <b>Investment value</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  ₹
                                  {unRealisedData[
                                    metal
                                  ].totalBuybackAmount.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{Math.abs(unInvestedSum).toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Mark to Market value</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  ₹
                                  {unRealisedData[
                                    metal
                                  ].totalSellAmount.toFixed(2)}
                                </td>
                              ))}
                            <td className='right-align'>
                              ₹{Math.abs(markToMarkSum).toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td className='left-align'>
                              <b>Metal Holdings</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-invst`}
                                  className='right-align'
                                >
                                  {unRealisedData[
                                    metal
                                  ].totalSellQuantity.toFixed(4)}
                                  g
                                </td>
                              ))}
                            <td className='center-align'>-</td>
                          </tr>

                          {/* <tr>
                      <td>
                        <b>Balance Metal</b>
                      </td>
                      {unRealisedData &&
                        Object.keys(unRealisedData).map((metal) => (
                          <td key={`${metal}-invst`}>
                            ₹{unRealisedData[metal].finalAmount.toFixed(2)}
                          </td>
                        ))}
                    </tr> */}
                          {/* <tr>
                          <td className="left-align">
                            <b>Gain / Loss (INR)</b>
                          </td>
                          {/* {unRealisedData &&
                        Object.keys(unRealisedData).map((metal) => (
                          <td key={`${metal}-pp`}>
                            {unRealisedData[metal].totalBuybackAmount +
                              unRealisedData[metal].finalAmount -
                              unRealisedData[metal].totalSellAmount >
                            0 ? (
                              <img
                                src={upArrow}
                                style={{ marginRight: '5px' }}
                              />
                            ) : (
                              <img
                                src={downArrow}
                                style={{ marginRight: '5px' }}
                              />
                            )}
                            ₹
                            {Math.abs(
                              unRealisedData[metal].totalBuybackAmount +
                                unRealisedData[metal].finalAmount -
                                unRealisedData[metal].totalSellAmount
                            ).toFixed(2)}
                          </td>
                        ))} */}
                          {/* {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              style={{ padding: '5px' }}
                              className="right-align"
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',

                                }}
                                className="right-align"
                              >
                                {unRealisedData[metal].totalSellAmount -
                                  unRealisedData[metal].totalBuybackAmount >
                                  0 ? (
                                  <img
                                    src={upArrow}
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                    className="right-align"
                                  />
                                ) : (
                                  <img
                                    src={downArrow}
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                    className="right-align"
                                  />
                                )}
                                <span className="right-align">
                                  ₹
                                  {Math.abs(
                                    unRealisedData[metal].totalSellAmount -
                                    unRealisedData[metal].totalBuybackAmount
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          ))} */}
                          {/* </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (INR)</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  style={{ padding: '5px' }}
                                  className='right-align'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {unRealisedData[metal].totalSellAmount -
                                      unRealisedData[metal]
                                        .totalBuybackAmount !=
                                    0 ? (
                                      unRealisedData[metal].totalSellAmount -
                                        unRealisedData[metal]
                                          .totalBuybackAmount >
                                      0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span>
                                      ₹
                                      {Math.abs(
                                        unRealisedData[metal].totalSellAmount -
                                          unRealisedData[metal]
                                            .totalBuybackAmount
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                </td>
                              ))}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unrealisedPLSum != 0 ? (
                                  unrealisedPLSum > 0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹{Math.abs(unrealisedPLSum).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          </tr>

                          {/* <tr>
                          <td className='left-align'>
                            <b>Gain / Loss (%)</b>
                          </td>
                          {unRealisedData &&
                            Object.keys(unRealisedData).map((metal) => (
                              <td
                                key={`${metal}-pp`}
                                style={{ padding: '5px' }}
                                className="right-align"
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                  className="right-align"
                                >
                                  {unRealisedData[
                                    metal
                                  ].totalSellAmount.toFixed(2) -
                                    unRealisedData[
                                      metal
                                    ].totalBuybackAmount.toFixed(2) >
                                    0 ? (
                                    <img
                                      src={upArrow}
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                      className="right-align"
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                      className="right-align"
                                    />
                                  )}
                                  <span className="right-align">
                                    {unRealisedData[metal].totalBuybackAmount >
                                      0
                                      ? Math.abs(
                                        ((unRealisedData[metal]
                                          .totalSellAmount -
                                          unRealisedData[metal]
                                            .totalBuybackAmount) /
                                          unRealisedData[metal]
                                            .totalBuybackAmount) *
                                        100
                                      ).toFixed(2)
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </td>
                            ))}

                          {/* <td>
                      <img src={downArrow} style={{ marginRight: '5px' }} />
                      ₹200.00
                    </td> */}
                          {/* </tr> */}

                          <tr>
                            <td className='left-align'>
                              <b>Gain / Loss (%)</b>
                            </td>
                            {unRealisedData &&
                              Object.keys(unRealisedData).map((metal) => (
                                <td
                                  key={`${metal}-pp`}
                                  style={{ padding: '5px' }}
                                  className='right-align'
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                    }}
                                  >
                                    {unRealisedData[
                                      metal
                                    ].totalSellAmount.toFixed(2) -
                                      unRealisedData[
                                        metal
                                      ].totalBuybackAmount.toFixed(2) !=
                                    0 ? (
                                      unRealisedData[
                                        metal
                                      ].totalSellAmount.toFixed(2) -
                                        unRealisedData[
                                          metal
                                        ].totalBuybackAmount.toFixed(2) >
                                      0 ? (
                                        <img
                                          src={upArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={downArrow}
                                          className='arrow-icon'
                                          style={{
                                            marginRight: '5px',
                                            marginBottom: '-4px',
                                          }}
                                        />
                                      )
                                    ) : (
                                      ''
                                    )}
                                    <span className='right-align'>
                                      {unRealisedData[metal]
                                        .totalBuybackAmount > 0
                                        ? Math.abs(
                                            ((unRealisedData[metal]
                                              .totalSellAmount -
                                              unRealisedData[metal]
                                                .totalBuybackAmount) /
                                              unRealisedData[metal]
                                                .totalBuybackAmount) *
                                              100
                                          ).toFixed(2)
                                        : unRealisedData[metal]
                                            .totalSellAmount > 0
                                        ? 100
                                        : 0}
                                      %
                                    </span>
                                  </div>
                                </td>
                              ))}
                            {/* <td className='center-align'>-</td> */}
                            <td
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unrealisedPLSumPer !== 0 ? (
                                  <>
                                    {unrealisedPLSumPer > 0 ? (
                                      <img
                                        src={upArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={downArrow}
                                        className='arrow-icon'
                                        style={{
                                          marginRight: '5px',
                                          marginBottom: '-4px',
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                                <span>
                                  {unrealisedPLSumPer !== 0? Math.abs(unrealisedPLSumPer).toFixed(2):0}%
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <div className='mt-2 text-center' style={{fontSize:"14px",color:"#000000"}}>
                    *Note: Gifts are currently displayed as an investment by the
                    sender, resulting in a deficit for the sender, and as a
                    gains for the recipient.
                  </div>
                </>
              )
            )}
          </Row>

          {/* <SupportButton /> */}
        </div>
      )}
      {/* {customer.customerCategory === 'UNREGISTERED' &&
        customer?.nomineeDetails?.length < 1 && <NomineeModal />} */}
      {customer.giftCount > 0 && customer?.customerCategory === 'UNREGISTERED' && (
        <RedeemGiftModal
          showModal={open}
          closeModal={setOpen}
          proceed={claimGift}
          cancel={onCancel}
          text={`
      
            You have received a gift🎁
            To claim it, please go to Gift Page.
            Thank you!
         
        `}
          keytext={'gift'}
          okButton={'Go to Gift'}
          cancelButton={'Later'}
          title={'Your Gift Awaits!'}
        />
      )}
    </Layout>
  );
};

export default DashboardPage;
